import { render, staticRenderFns } from "./energyTips.vue?vue&type=template&id=b3f4cca4&scoped=true"
import script from "./energyTips.vue?vue&type=script&lang=js"
export * from "./energyTips.vue?vue&type=script&lang=js"
import style0 from "./energyTips.vue?vue&type=style&index=0&id=b3f4cca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f4cca4",
  null
  
)

export default component.exports